import { Avatar, Button, Dropdown, Navbar } from "flowbite-react";
import React from "react";
import logo from '../../Media/logo.png'

const Header = () => {
  return (
    <Navbar
  fluid={true}
  rounded={true}
>
  <Navbar.Brand href="https://flowbite.com/">
    <img src={logo} alt="" />
  </Navbar.Brand>
  <div className="flex md:order-2">
    <Dropdown
      arrowIcon={false}
      inline={true}
      label={<Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded={true}/>}
    >
      <Dropdown.Header>
        <span className="block text-sm">
          Bonnie Green
        </span>
        <span className="block truncate text-sm font-medium">
          name@flowbite.com
        </span>
      </Dropdown.Header>
      <Dropdown.Item>
        Dashboard
      </Dropdown.Item>
      <Dropdown.Item>
        Settings
      </Dropdown.Item>
      <Dropdown.Item>
        Earnings
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item>
        Sign out
      </Dropdown.Item>
    </Dropdown>
    <Navbar.Toggle />
  </div>
  <Navbar.Collapse>
    <Navbar.Link
      href="/navbars"
      active={true}
    >
      <span className="text-xl">Life on LINE</span>
    </Navbar.Link>
    <Navbar.Link href="/navbars">
    <span className="text-xl">Messenger APP</span>
    </Navbar.Link>
    <Navbar.Link href="/navbars">
    <span className="text-xl">Services</span>
    </Navbar.Link>
    
  </Navbar.Collapse>
</Navbar>
  );
};

export default Header;
